<template>
  <force-landscape
    v-show="visible"
    :forceLandscape="needForceLandscape"
    style="z-index: 6"
  >
    <div
      class="mask"
      @click="hide"
    ></div>
    <div
      class="download-wrap"
      :style="[isMobile ? {
        width: mWidth,
        height: mHeight,
        backgroundImage: imageUrl
      } : {
        width: '35%',
        height: '100%',
        backgroundImage: imageUrl
      }]"
      @click="handleDownload"
    >
      <div
        v-if="showCloseBtn"
        class="closebtn"
        @click="hide"
      ></div>
    </div>
  </force-landscape>
</template>

<script>
import { DEVICE_TYPE, isNikke, isPubgm } from "@/constant";
import ForceLandscape from "@/components/layout/ForceLandscape.vue";

export default {
  name: "DowloadBox",
  components: {
    ForceLandscape,
  },
  data() {
    return {
      visible: false,
      isMobile: DEVICE_TYPE.isMobile,
      imageUrl: "",
      needHide: false,
      type: "",
      needForceLandscape: false,
      mWidth: "",
      mHeight: "",
      showCloseBtn: false,
    };
  },
  mounted() {
    this.checkStyle();
  },
  methods: {
    checkStyle() {
      if (isNikke()) {
        this.mWidth = "100vmin";
        this.mHeight = "70vmax";
        return;
      }
      if (isPubgm()) {
        this.mWidth = "80%";
        this.mHeight = "90vmin";
      }
    },
    hide() {
      this.visible = false;
    },
    handleDownload() {
      if (this.needHide) {
        this.visible = false;
      }
    },
  },
};
</script>

<style scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 4;
  background: rgba(0, 0, 0, 0.5);
}
.download-wrap {
  position: fixed;
  z-index: 5;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100vmin;
  height: 75vmax;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  pointer-events: auto;
}
.closebtn {
  background-image: url(../../../assets/hok/guanbi.png);
  position: fixed;
  right: 38vmin;
  top: 2vmin;
  color: black;
  background-size: 100% 100%;
  width: 30px;
  height: 30px;
  z-index: 4;
}
</style>